import React from "react";
import {BackgroundImage,TeethLogo,DentalServiceComponent, ServiceBottomButton} from "../../Components"

const DentalService = (props) => {
    const { selectedLanguage } = props

    return(
        <div className="main">
            <BackgroundImage heading={selectedLanguage?.services_dental_diagnoses_and_gp_heading} text={selectedLanguage?.txt_explore_our_services} mainClass='dental-service-background'/>
            <TeethLogo heading={selectedLanguage?.services_dental_diagnoses_and_gp_heading} />
            <DentalServiceComponent/>
            <ServiceBottomButton {...props} />
        </div>
    )
}

export default DentalService